import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthProvider";
import BackdropLoader from "../components/backdrop-loader";

interface ProtectedRouteProps {
  children: React.ReactElement;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { authStatus } = useContext(AuthContext);

  if (authStatus === "loading") {
    return <BackdropLoader />;
  }

  if (authStatus === "unauthorized") {
    return <Navigate to="/sign-in" replace />;
  }

  return children;
}
